import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

export const exportProjectDashboardToPDF = (dashboardData) => {
  const doc = new jsPDF();
  
  doc.setFontSize(20);
  doc.setTextColor(40, 40, 40);
  doc.text('VALHALLA CORPORATIONS', 20, 20);
  doc.setFontSize(14);
  doc.text(dashboardData?.project?.name || 'Project Report', 20, 30);
  doc.setFontSize(10);
  doc.setTextColor(120, 120, 120);
  doc.text('Estado: ' + (dashboardData?.project?.status || 'N/A'), 20, 38);
  doc.text('Progreso: ' + (dashboardData?.progress?.progress_percentage || 0) + '%', 20, 44);
  doc.text('Fecha: ' + new Date().toLocaleDateString('es-ES'), 20, 50);
  
  if (dashboardData?.tasks_by_employee?.length > 0) {
    doc.autoTable({
      startY: 60,
      head: [['Empleado', 'Tareas Totales', 'Completadas', 'En Progreso']],
      body: dashboardData.tasks_by_employee.map(emp => [
        emp.employee_name || 'N/A',
        emp.total_tasks || 0,
        emp.completed_tasks || 0,
        emp.in_progress_tasks || 0
      ]),
      theme: 'striped',
      headStyles: { fillColor: [226, 176, 94] },
    });
  }
  
  if (dashboardData?.hours_by_employee?.length > 0) {
    const startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : 70;
    doc.setFontSize(12);
    doc.setTextColor(40, 40, 40);
    doc.text('Horas por Empleado', 20, startY - 5);
    
    doc.autoTable({
      startY: startY,
      head: [['Empleado', 'Total Horas', 'Facturables', 'No Facturables']],
      body: dashboardData.hours_by_employee.map(emp => [
        emp.employee_name || 'N/A',
        (emp.total_hours || 0).toFixed(2),
        (emp.billable_hours || 0).toFixed(2),
        (emp.non_billable_hours || 0).toFixed(2)
      ]),
      theme: 'striped',
      headStyles: { fillColor: [58, 184, 214] },
    });
  }
  
  if (dashboardData?.financial_summary) {
    const startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : 150;
    doc.setFontSize(12);
    doc.text('Resumen Financiero', 20, startY - 5);
    
    const fin = dashboardData.financial_summary;
    doc.autoTable({
      startY: startY,
      head: [['Concepto', 'Valor']],
      body: [
        ['Presupuesto', '$' + (fin.budget || 0).toLocaleString()],
        ['Facturado', '$' + (fin.invoiced || 0).toLocaleString()],
        ['Pagado', '$' + (fin.paid || 0).toLocaleString()],
        ['Costo Laboral', '$' + (fin.labor_cost || 0).toLocaleString()],
        ['Margen', '$' + (fin.margin || 0).toLocaleString()],
      ],
      theme: 'striped',
      headStyles: { fillColor: [40, 167, 69] },
    });
  }
  
  doc.save('proyecto-' + (dashboardData?.project?.project_id || 'report') + '-reporte.pdf');
};

export const exportSubscriptionsToExcel = (subscriptions) => {
  const worksheet = XLSX.utils.json_to_sheet(
    subscriptions.map(sub => ({
      'Servicio': sub.service_name || sub.name || 'N/A',
      'Cliente': sub.client_name || 'N/A',
      'Proveedor': sub.provider_name || sub.provider || 'N/A',
      'Tipo': sub.transaction_type || 'N/A',
      'Frecuencia': sub.billing_frequency || sub.frequency || 'N/A',
      'Dia de cobro': sub.billing_day || 'N/A',
      'Cantidad Licencias': sub.transaction_type === 'licencia' ? (sub.license_quantity || 1) : 'N/A',
      'Precio Unitario Cliente': sub.transaction_type === 'licencia' ? (sub.client_unit_price || 0) : 'N/A',
      'Costo Unitario Proveedor': sub.transaction_type === 'licencia' ? (sub.provider_unit_cost || 0) : 'N/A',
      'Precio Cliente': sub.client_rate || sub.price || 0,
      'Costo Proveedor': sub.provider_cost || sub.cost || 0,
      'Alcance': (sub.scope_items || []).join('; '),
      'Ultimo Periodo Generado': sub.last_generated_billing_period || 'N/A',
      'Ultima Cotizacion Generada': sub.last_generated_quotation_number || 'N/A',
      'Estado': sub.status || 'N/A'
    }))
  );
  
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Transacciones recurrentes');
  XLSX.writeFile(workbook, 'transacciones-recurrentes.xlsx');
};

export const exportTimesheetsToExcel = (timesheets) => {
  const worksheet = XLSX.utils.json_to_sheet(
    timesheets.map(ts => ({
      'Empleado': ts.employee_name || 'N/A',
      'Proyecto': ts.project_name || 'N/A',
      'Fecha': ts.date ? new Date(ts.date).toLocaleDateString('es-ES') : 'N/A',
      'Horas': ts.hours || 0,
      'Categoria': ts.billing_category || 'N/A',
      'Estado': ts.status || 'N/A',
      'Descripcion': ts.description || ts.notes || ''
    }))
  );
  
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Timesheets');
  XLSX.writeFile(workbook, 'timesheets.xlsx');
};

export const exportBillingMetricsToPDF = (metrics, periodLabel) => {
  const doc = new jsPDF();
  
  doc.setFontSize(20);
  doc.setTextColor(40, 40, 40);
  doc.text('VALHALLA CORPORATIONS', 20, 20);
  doc.setFontSize(14);
  doc.text('Overview de Facturacion', 20, 30);
  doc.setFontSize(10);
  doc.setTextColor(120, 120, 120);
  doc.text('Periodo: ' + (periodLabel || 'N/A'), 20, 38);
  doc.text('Fecha: ' + new Date().toLocaleDateString('es-ES'), 20, 44);
  
  doc.autoTable({
    startY: 55,
    head: [['Metrica', 'Valor']],
    body: [
      ['Dinero entrante', '$' + (metrics?.money_in || 0).toLocaleString()],
      ['Dinero saliente', '$' + (metrics?.money_out || 0).toLocaleString()],
      ['Flujo neto', '$' + (metrics?.net_cash_flow || 0).toLocaleString()],
      ['Cuentas por cobrar', '$' + (metrics?.accounts_receivable || 0).toLocaleString()],
      ['Facturado', '$' + (metrics?.total_invoiced || 0).toLocaleString()],
      ['Gastos contables', '$' + (metrics?.accounting_expenses || 0).toLocaleString()],
      ['Pagos a proveedores', '$' + (metrics?.supplier_payments || 0).toLocaleString()],
    ],
    theme: 'striped',
    headStyles: { fillColor: [226, 176, 94] },
  });
  
  if (metrics?.by_client?.length > 0) {
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 15,
      head: [['Cliente', 'Facturas', 'Cobrado']],
      body: metrics.by_client.map(item => [
        item.client_name,
        item.count || 0,
        '$' + (item.paid || 0).toLocaleString()
      ]),
      theme: 'striped',
      headStyles: { fillColor: [58, 184, 214] },
    });
  }
  
  if (metrics?.by_supplier?.length > 0) {
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 15,
      head: [['Proveedor', 'Pagos', 'Pagado']],
      body: metrics.by_supplier.map(item => [
        item.supplier_name,
        item.count || 0,
        '$' + (item.paid || 0).toLocaleString()
      ]),
      theme: 'striped',
      headStyles: { fillColor: [40, 167, 69] },
    });
  }
  
  doc.save('facturacion-reporte-' + new Date().toISOString().slice(0,10) + '.pdf');
};

export const exportGenericToExcel = (data, sheetName, fileName) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
};
